import { css } from 'styled-components'

export const SALES_REPORT_FONT = "'Inter', sans-serif"

export const colors = {
  primary: '#e9030f',
  primaryRgb: '233, 3, 15',
  primaryStrong: '#d7030e',
  primaryForeground: '#fafafa',
  kpiIconBg: '#fee6e8',
  courtesyBg: '#f4cacc',
  positive: '#079455',
  positiveBg: '#dcfce7',
  positiveOnDark: '#07bc0c',
  ink950: '#0a0a0a',
  ink900: '#171717',
  ink800: '#262626',
  ink700: '#404040',
  ink600: '#525252',
  ink500: '#737373',
  ink400: '#a3a3a3',
  border: '#e5e5e5',
  tableBorder: '#e0e0e0',
  rowDivider: '#f5f5f5',
  checkboxBorder: '#d4d4d4',
  subtotal: '#d4d4d4',
  mobileSubtotal: '#eaeaea',
  accent: '#f5f5f5',
  zebra: '#fafafa',
  groupHeader: '#e5e5e5',
  badgeDark: '#121212',
  badgeMuted: '#e5e5e5',
  totalBar: '#262626',
  white: '#ffffff',
  warning: '#f59e0b',
  warningText: '#b45309',
  warningBg: '#fef3c7',
  danger: '#dc2626',
  dangerText: '#b91c1c',
  dangerBg: '#fee2e2',
}

export const radius = {
  input: '8px',
  card: '12px',
  kpiIcon: '11px',
  tabs: '10px',
  table: '16px',
  badge: '24px',
  pill: '9999px',
  checkbox: '4px',
  progress: '3px',
  segment: '2px',
}

export const fontScope = css`
  &,
  & * {
    font-family: ${SALES_REPORT_FONT} !important;
  }

  & img {
    width: auto;
    height: auto;
    max-width: none;
  }
`

export const fieldLabel = css`
  font-size: 11px;
  font-weight: 700;
  line-height: 16.5px;
  letter-spacing: 0.66px;
  text-transform: uppercase;
  color: ${colors.ink400};
`

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`
